import { withDevtools } from '@angular-architects/ngrx-toolkit';
import { inject } from '@angular/core';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { setEntity } from '@ngrx/signals/entities';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { patchErrorRequestStatus, setSubmitFulfilled, setSubmitPending, withRequestStatus } from '@pflegix/store';
import { UpdateBusinessPartnerNotesDto } from '@pflegix/types';
import { ToastService } from '@pflegix/ui';
import { lastValueFrom, pipe, tap } from 'rxjs';
import { BusinessPartnerStore } from '../../store';
import { NotesFormApi } from '../api/notes-form.api';

export const NotesFormStore = signalStore(
  { protectedState: false },
  withDevtools('notes'),
  withState<{ id: string | undefined }>({ id: undefined }),
  withRequestStatus(),
  withMethods(
    (
      store,
      api = inject(NotesFormApi),
      bpStore = inject(BusinessPartnerStore),
      toastService = inject(ToastService)
    ) => ({
      setBusinessPartnerId: rxMethod<string>(pipe(tap((id) => patchState(store, { id })))),
      updateNotes: async (id: string, notes: UpdateBusinessPartnerNotesDto): Promise<void> => {
        patchState(store, setSubmitPending());

        try {
          const businessPartner = await lastValueFrom(api.updateNotes(id, notes));

          toastService.addSuccessToast('Daten erfolgreich aktualisiert');

          patchState(bpStore, setEntity(businessPartner, { selectId: (entity) => entity._id }));
        } catch (error) {
          patchErrorRequestStatus(store, error);
        } finally {
          patchState(store, setSubmitFulfilled());
        }
      },
    })
  )
);
